import Vue from 'vue'

// axios
import axios from 'axios'
import { getApiBase } from '@/libs/endpoints'

const apiBase = getApiBase()

const axiosIns = axios.create({
  // You can add your headers here
  // ================================
  baseURL: apiBase,
  // timeout: 1000,
  // headers: {'X-Custom-Header': 'foobar'}
})

export const mediaBaseURL = apiBase

Vue.prototype.$http = axiosIns
Vue.prototype.$apiBase = apiBase

export default axiosIns
